import { useEffect } from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'
import Footer from 'src/components/common/Footer'

import { useParams } from 'react-router-dom'
import Loading from 'src/components/common/Loading'
import Banner from 'src/components/join/Banner'
import JoinSubmit from 'src/components/join/JoinSubmit'
import MvnoModal from 'src/components/join/MvnoModal'
import PhoneVerification from 'src/components/join/PhoneVerification'
import Terms from 'src/components/join/Terms'
import useAPI from 'src/hooks/useAPI'
import useMoveScroll from 'src/hooks/useMoveScroll'
import useSubmit from 'src/hooks/useSubmit'
import { PartnerState, TelTypeState, TermsListState, uiData } from 'src/recoil/ui'
import { convertTermsData, modifyUiData } from 'src/service/join'
import { MainWrap } from 'src/styles/views/join/MainWrap'

const Join = () => {
  const { pcode, telecom } = useParams()
  const getPartner = useAPI('GetPartnerInfo')
  const getTerms = useAPI('PartnerTerms')
  const submit = useSubmit(pcode ?? '')

  const setPartnerData = useSetRecoilState(PartnerState)
  const [
    {
      layoutsInsert: { mainBg },
    },
    setUiData,
  ] = useRecoilState(uiData)
  const setTelType = useSetRecoilState(TelTypeState)
  const setTermsList = useSetRecoilState(TermsListState)

  const { data: getPartnerData, isSuccess, isLoading } = getPartner?.useSetQuery({ PCODE: pcode })
  const { data: getTermsData, isSuccess: termsSuccess } = getTerms?.useSetQuery()
  const { RefElement, onMoveToElement, RefInput } = useMoveScroll()

  useEffect(() => {
    setTelType(!!Number(telecom) ? Number(telecom) : 0)
  }, [telecom, setTelType])

  useEffect(() => {
    if (isSuccess && getPartnerData?.Body) {
      setPartnerData(getPartnerData?.Body)
      !!getPartnerData.Body.UiData && setUiData(modifyUiData(getPartnerData.Body.UiData))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, getPartnerData])

  useEffect(() => {
    window.onbeforeunload = function pushRefresh() {
      window.scrollTo(0, 0)
    }
  }, [isSuccess])

  useEffect(() => {
    if (termsSuccess && getTermsData?.Body) {
      setTermsList((org) => convertTermsData(getTermsData?.Body ?? org))
    }
  }, [termsSuccess, getTermsData, setTermsList])

  return (
    <>
      <Loading active={isLoading} />
      {isSuccess && (
        <>
          <Banner RefElement={RefElement} />
          <MainWrap mainBg={mainBg}>
            <PhoneVerification
              onMoveToElement={onMoveToElement}
              RefInput={RefInput}
              submit={submit}
            />
            <Terms />
            <JoinSubmit submit={submit} />
            <Footer />
          </MainWrap>
        </>
      )}

      <MvnoModal submit={submit} />
    </>
  )
}

export default Join
